import { Card, Divider } from 'antd';
import { MembershipAssignmentPanel } from './MembershipAssignmentPanel';
import { PackAssignmentsPanel } from './PackAssignmentsPanel';

export interface AssignmentSectionProps {
  customerId: string;
  customerName?: string;
  /** Solo `SUPER_ADMIN`; el resto consulta en modo lectura. */
  canWrite: boolean;
  /** Refresca la ficha del cliente tras asignar/cancelar. */
  onChanged?: () => void;
}

/**
 * Sección **“Packs y membresía”** de la ficha del cliente (US-2.4, TG-53).
 *
 * Agrupa la asignación de packs (N activos + histórico) y la membresía única activa
 * con su historial, además de los comprobantes de pago de cada asignación.
 */
export function AssignmentSection({
  customerId,
  customerName,
  canWrite,
  onChanged,
}: AssignmentSectionProps) {
  return (
    <Card title="Packs y membresía">
      <PackAssignmentsPanel
        customerId={customerId}
        customerName={customerName}
        canWrite={canWrite}
        onChanged={onChanged}
      />
      <Divider />
      <MembershipAssignmentPanel
        customerId={customerId}
        customerName={customerName}
        canWrite={canWrite}
        onChanged={onChanged}
      />
    </Card>
  );
}
